import BrandsBase from "./BrandsBase/BrandsBase";

const DataCollectionBrands = () => {
  return (
    <div>
      <BrandsBase />
    </div>
  );
};

export default DataCollectionBrands;
